import isUndefined from 'lodash/isUndefined';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {destinationLoadEvents} from 'destination/destination-actions';
import {push} from 'router/router-actions';

export default EnhancedComponent => {
    class WithEventList extends Component {
        static propTypes = {
            city: PropTypes.object,
            destination: PropTypes.object,
            loadEvents: PropTypes.func.isRequired,
            pushTo: PropTypes.func.isRequired
        };
        state = {
            isLoading: true
        };

        constructor(props) {
            super(props);

            this._isStateful = !isUndefined(EnhancedComponent.prototype.render);
        }

        _onEventSelected = event => {
            this.props.pushTo(`/${event.search_url}`);
        }

        _loadData = () => {
            this._asyncLoadData();
        }

        async _asyncLoadData() {
            const {
                destination: {
                    id
                },
                loadEvents
            } = this.props;

            try {
                await loadEvents({
                    destinationId: id
                });
            } catch (error) {
                console.log('WithEventList._loadData() error:', error); // eslint-disable-line no-console
            }

            this.setState({
                isLoading: false
            });
        }

        render() {
            const allProps = {
                ...this.props,
                loadData: this._loadData,
                isLoading: this.state.isLoading,
                onEventSelected: this._onEventSelected
            };

            if (this._isStateful) {
                allProps.ref = node => { this._wrappedInstance = node; };
            }

            return (
                <EnhancedComponent
                    {...allProps}
                />
            );
        }
    }

    const mapStateToProps = state => {
        const {
            city: {
                data: cityData
            },
            destination: {
                data: destinationData
            }
        } = state;

        return {
            city: cityData,
            destination: destinationData
        };
    };

    const mapDispatchToProps = {
        loadEvents: destinationLoadEvents,
        pushTo: push
    };

    return connect(mapStateToProps, mapDispatchToProps)(WithEventList);
};
